import ky from "ky"
import qs from "qs"

const http = ky.create({
  headers: {
    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.content,
  },
})

const parse = async (response) => {
  const contentType = (await response).headers.get("content-type")

  if (contentType && contentType.indexOf("application/json") !== -1) {
    return { data: await response.json() }
  }

  return response
}

export const client = {
  get: (url, options = {}) => parse(http.get(url, {
    ...options,
    searchParams: qs.stringify(options.params, {
      arrayFormat: "brackets",
      skipNulls: true,
    }),
  })),
  post: (url, json) => parse(http.post(url, { json })),
  delete: (url, json) => parse(http.delete(url, { json })),
  patch: (url, json) => parse(http.patch(url, { json })),
  put: (url, json) => parse(http.put(url, { json })),
}
